const scrollToAnchor = (idElement) => {
  const element_to_scroll_to = document.getElementById(idElement);
  element_to_scroll_to.scrollIntoView({ behavior: "smooth" });
};

export default scrollToAnchor;
